import React, { Component } from "react";
import { Link } from "react-router-dom";
import Localization from "../localization/localization"

class Landing extends Component {

  constructor() {
    super();
    this.locale = Localization.getLocalizationInstance(localStorage.getItem("exmi_language"));
  }

  render() {
    return (
      <div class="col s12 m12 l8 container">
        <div class="col s12 l10 offset-l1 center contentaligned valign-wrapper">
          <div>
            <div className="font-face-mb titulo">
              <h3>
                {this.locale.layout_landing_label_new_register}
              </h3>
            </div>
            <div className="subTitulo">
              <h6>
                {this.locale.layout_landing_label_new_details}
              </h6>
            </div>
            <br />
            <div className="col s12 m12 l12">
              <Link
                to="/rules/register"
                style={{
                  width: "370px",
                  borderRadius: "3px",
                  letterSpacing: "1.5px",
                  marginTop: "1rem"
                }}
                className="btn-large hoverable buttonBackgroundColor"
              >
                {this.locale.layout_landing_button_register}
              </Link>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <div className="font-face-mb titulo">
              <h3>
                {this.locale.layout_landing_label_recurrent}
              </h3>
            </div>
            <div className="subTitulo">
              <h6>
                {this.locale.layout_landing_label_recurrent_details}
              </h6>
            </div>
            <br />
            <div className="col s12 m12 l12">
              <Link
                to="/rules/login"
                style={{
                  width: "320px",
                  borderRadius: "3px",
                  letterSpacing: "1.5px",
                  marginTop: "1rem"
                }}
                className="btn-large hoverable buttonBackgroundColor"
              >
                {this.locale.layout_landing_button_login}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Landing;
